import { Routes } from '@angular/router';
import { legacyUrlCanonicalizerGuard } from '../guards/legacy-url-canonicalizer.guard';

/** Wraps route tables so every navigation passes through the legacy URL canonicalizer once. */
export function withLegacyUrlCanonicalizer(routes: Routes): Routes {
  return [
    {
      path: '',
      canActivate: [legacyUrlCanonicalizerGuard],
      children: routes,
    },
  ];
}
